module.exports = __webpack_public_path__ + "static/media/tree-branches.453dbc77.svg";